import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getTalkDetails } from '../utils/services';
import talksMock from '../mocks/talks';
import speakersMock from '../mocks/speakers';

const { Consumer, Provider } = React.createContext();

const TalkDetailsProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [speakers, setSpeakers] = useState([]);
  const [talks, setTalks] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const loadTalkDetails = async talkId => {
    setIsLoading(true);
    try {
      // const details = await getTalkDetails(talkId);
      // setSpeakers(details.speakers);
      // setTalks(details.talks);
      setSpeakers(speakersMock);
      setTalks(talksMock);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Provider
      value={{
        isLoading,
        speakers,
        talks,
        loadTalkDetails
      }}>
      {children}
    </Provider>
  );
};

TalkDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { TalkDetailsProvider, Consumer as TalkDetailsConsumer };
